// src/api/fileService.js
import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/metadata/ayah`;

// Create axios instance with authentication
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); // Adjust based on your auth implementation
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized access
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const fetchAyah = async (surahId, translation_id='2') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${surahId}`, {
      params: {
        translation_id
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching surah:', error);
    throw error;
  }
};

export const verifyAyah = async (ayahKey, status, comment, correction) => {
  try {
    await api.post(`${API_BASE_URL}/verification`, {
      ayah_key: ayahKey,
      verification_status: status,
      comments: comment || '',
      corrections: correction || ''
    });
  } catch (error) {
    console.error('Error deleting verification:', error);
    throw new Error('Failed to delete verification');
  }
}

export const deleteVerification = async (ayah_key) => {
  try {
    await api.delete(`${API_BASE_URL}/verification`, {
      params:{
        ayah_key,
      }
    });
  } catch (error) {
    console.error('Error deleting verification:', error);
    throw new Error('Failed to delete verification');
  }
}

// ========== SUPER_EXPERT ENDPOINTS ==========

export const fetchAyahForApproval = async (surahId) => {
  try {
    const response = await api.get(`/super-expert/${surahId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching audio for approval:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch audio for approval');
  }
};

export const approveAyah = async (ayahKey, status, notes) => {
  try {
    const response = await api.post(`/approval`, {
      ayah_key: ayahKey,
      approval_status: status,
      approval_notes: notes || ''
    });
    return response.data;
  } catch (error) {
    console.error('Error approving audio:', error);
    throw new Error(error.response?.data?.detail || 'Failed to approve audio');
  }
};

export const revokeApproval = async (ayah_key) => {
  try {
    const response = await api.delete(`/approval`, {
      params: { ayah_key }
    });
    return response.data;
  } catch (error) {
    console.error('Error revoking approval:', error);
    throw new Error(error.response?.data?.detail || 'Failed to revoke approval');
  }
};

export const fetchApprovalStats = async () => {
  try {
    const response = await api.get(`/approval-stats`);
    return response.data;
  } catch (error) {
    console.error('Error fetching approval stats:', error);
    throw error;
  }
};



